import React from "react";
import { FeaturedImage, RightArrow } from "../../core/constants/Images";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import galleryContentData from "./galleryData";
import GallerySliderCard from "./GallerySliderCard";
import "./Gallery.css";

const OurAchievement = () => {
  var gallerySliderSettings = {
    dots: true,
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 640,
        settings: {
          dots: true,
          slidesToShow: 1,
          swipeToSlide: true,
        },
      },
    ],
  };
  return (
    <div>
      <div id="updates">
        {/* <p className="text-gray-500 mb-1">Where you can help</p> */}
        <div className="flex justify-center">
          <h2 className="font-bold tracking-wide text-2xl md:text-3xl mb-5">
            Recent Updates
            <div class="animation h-1 mt-1"></div>
          </h2>
        </div>
      </div>
      <div className="md:flex w-full md:my-8 gap-4">
        <Slider {...gallerySliderSettings}>
  {galleryContentData &&
    galleryContentData
      .slice()
      .reverse()
      .map((item, index) => {
        return (
          <div className="pb-4" key={index}>
            <GallerySliderCard
              imageData={item}
              isFirstCard={index === 5}
            />
          </div>
        );
      })}
</Slider>

      </div>
    </div>
  );
};

export default OurAchievement;
